// =========================================================
// * Vuetify Material Dashboard PRO - v2.0.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

// hoc
import DebounceVBtn from '@/components/hoc/DebounceVBtn.js'

Vue.config.productionTip = false

Vue.use(require('vue-moment'))

new Vue({
  router,
  store,
  vuetify,
  i18n,
  beforeCreate () {
    this.$store.commit('loadBasketFromLocalStorage')
  },
  render: h => h(App),
}).$mount('#app')

// subscribe to store to sync certain values to localstorage
store.subscribe((mutation, state) => {
  if (mutation.type === 'updateBasket') {
    localStorage.setItem('store-order-basket', JSON.stringify(mutation.payload))
  }
})

Vue.component(`DebounceVBtn`, DebounceVBtn)
